import React from "react";

const readable = (value) => value === null || value === undefined ? "—"
  : typeof value === "object" ? JSON.stringify(value) : String(value);
const label = (key) => key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ");

export default function PlannerSaveRecoveryNotice({ recovery, planId }) {
  const notice = recovery.notice;
  if (!planId || !notice) return null;
  return <section className="mediaplanner-save-recovery" aria-label="Planner save recovery">
    <p role="status">{notice.message}</p>
    {notice.kind === "unknown" && <button type="button" onClick={() => recovery.recover(planId)}>Check save outcome</button>}
    {notice.kind === "review" && <button type="button" onClick={() => recovery.review(planId)}>Review saved inputs</button>}
    {notice.draft && <details open>
      <summary>Saved inputs to review</summary>
      <dl>{Object.entries(notice.draft.formData || {}).filter(([key]) => !["advertiserId", "plannerInputIntent"].includes(key)).map(([key, value]) =>
        <React.Fragment key={key}><dt>{label(key)}</dt><dd>{readable(value)}</dd></React.Fragment>)}</dl>
      {notice.draft.strategy && <p>{notice.draft.strategy}</p>}
      <button type="button" onClick={() => recovery.keepBrowserEdits(planId, notice.draft)}>Keep browser edits</button>
    </details>}
  </section>;
}
